import { Probe } from "@/pages/heat-report/models/HeatReportModels";
import { getMomentTz } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef } from "ag-grid-enterprise";
const moment = getMomentTz();

export const useTableData = () => {
	const columns: ColGroupDef[] = [
		{
			headerName: "Charges",
			children: [
				{
					field: "Timestamp",
					headerName: "Time",
					flex: 1,
					minWidth: 61,
					cellStyle: {
						textAlign: "center",
					},
					valueGetter: (params: any) => {
						if (params.data.Timestamp) {
							return moment((params.data as Probe).Timestamp).format("HH:mm");
						}
					},
				},
				{
					field: "ChargeCode",
					headerName: "Code",
					flex: 1,
					minWidth: 66,
					cellStyle: {
						textAlign: "center",
					},
					valueGetter: (params: any) => {
						if (params.data.ChargeCode) {
							return params.data.ChargeCode === "B"
								? "Bucket"
								: params.data.ChargeCode === "P"
									? "Pourback"
									: "Unknown";
						}
					},
				},
				{
					field: "Weight",
					headerName: "Scrap [lbs]",
					flex: 1,
					minWidth: 70,
					wrapHeaderText: true,
					headerStyle: {
						textAlign: "center",
					},
					cellStyle: {
						textAlign: "right",
					},
				},
			],
		},
	];

	const defaultColDef: ColDef = {
		filter: false,
		floatingFilter: false,
		sortable: false,
		resizable: false,
		editable: false,
		suppressHeaderMenuButton: true,
	};

	return { columns, defaultColDef };
};
